import React from "react";
import _ from "lodash";
import { useIntl } from "react-intl";
import { ColumnDefinition, RowDefinition } from "griddle-react";

import { Table } from "@ui/Table";
import { CellViewLink } from "@ui/Table/Cells";
import { CellAlbumsList } from "../../components/AlbumsList";
import { Track } from "../../models";
import { messages } from "../../messages";
import { CellArtistsList } from "../ArtistsList";

interface TrackListTableProps {
    tracks: Track[];
}

interface Row {
    entity: Track;
}

// Type the table component
type TypedTable = new () => Table<Row>;
const TypedTable = Table as TypedTable;

const TrackListTable = ({ tracks }: TrackListTableProps) => {
    const intl = useIntl();
    const data = _.map(tracks, (track) => {
        return {entity: track} as Row;
    });
    return (
        <TypedTable data={data} layout="basic">
            <RowDefinition>
                <ColumnDefinition
                    key="title"
                    id="entity.title"
                    title={intl.formatMessage(messages.trackColumnTitle)}
                    customComponent={CellViewLink} />
                <ColumnDefinition
                    key="isrc"
                    id="entity.isrc"
                    title={intl.formatMessage(messages.trackColumnIsrc)} />
                <ColumnDefinition
                    key="artists"
                    id="entity.artists"
                    title={intl.formatMessage(messages.trackColumnArtists)}
                    customComponent={CellArtistsList} />
                <ColumnDefinition
                    key="albums"
                    id="entity.albums"
                    title={intl.formatMessage(messages.trackColumnAlbums)}
                    customComponent={CellAlbumsList} />
                <ColumnDefinition
                    key="duration"
                    id="entity.durationFormatted"
                    title={intl.formatMessage(messages.trackColumnDuration)} />
            </RowDefinition>
        </TypedTable>
    );
};

export {
    TrackListTable,
    TrackListTableProps,
};
